import LZString from 'lz-string';

const STORAGE_KEY = 'sitemap_project_data_v1';

// ----------------------------------------------------------------------
// 💾 Local Storage Management
// ----------------------------------------------------------------------

export const saveProjectLocally = (data) => {
  try {
    const serialized = JSON.stringify(data);
    localStorage.setItem(STORAGE_KEY, serialized);
    return true;
  } catch (e) {
    console.error("Failed to save to local storage", e);
    return false;
  }
};

export const loadProjectLocally = () => {
  try {
    const serialized = localStorage.getItem(STORAGE_KEY);
    if (!serialized) return null;
    return JSON.parse(serialized);
  } catch (e) {
    console.error("Failed to load from local storage", e);
    return null;
  }
};

export const clearLocalProject = () => {
  localStorage.removeItem(STORAGE_KEY);
};

// ----------------------------------------------------------------------
// 🔗 URL Sharing (Compression)
// ----------------------------------------------------------------------

export const generateShareUrl = (data) => {
  try {
    const json = JSON.stringify(data);
    const compressed = LZString.compressToEncodedURIComponent(json);
    const url = new URL(window.location.href);
    url.searchParams.set('s', compressed);
    return url.toString();
  } catch (e) {
    console.error("Failed to generate share URL", e);
    return null;
  }
};

export const loadFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const compressed = params.get('s');
    if (!compressed) return null;

    const json = LZString.decompressFromEncodedURIComponent(compressed);
    if (!json) return null;
    
    return JSON.parse(json);
  } catch (e) {
    console.error("Failed to load from URL", e);
    return null;
  }
};